export default "__VITE_ASSET__CeF5wu5m__"